import { render, staticRenderFns } from "./warranty-record.vue?vue&type=template&id=0645e156&scoped=true&"
import script from "./warranty-record.vue?vue&type=script&lang=ts&"
export * from "./warranty-record.vue?vue&type=script&lang=ts&"
import style0 from "./warranty-record.vue?vue&type=style&index=0&id=0645e156&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0645e156",
  null
  
)

export default component.exports